import { ClipboardCheck } from "lucide-react";
import { money, fmtKST } from "@/lib/api";

const left = (b) => Math.max(0, Math.round((b.owed - b.paid - b.pending) * 100) / 100);
const show = (b) => b.collected && !b.past_due && left(b) > 0.005 && new Date(b.payment_due) - Date.now() > 86400000;

export const CollectNotice = ({ dropBalances = [], onPay }) => {
  const items = dropBalances.filter(show);
  if (!items.length) return null;
  return (
    <div data-testid="collect-notice" className="mt-6 rounded-2xl border border-sky-400/40 bg-sky-400/[0.07] p-4 sm:p-5">
      {items.map((b) => (
        <div key={b.drop_id} data-testid={`collect-notice-${b.drop_id}`} className="flex flex-wrap items-center gap-3 [&+&]:mt-3 [&+&]:border-t [&+&]:border-sky-400/15 [&+&]:pt-3">
          <span className="inline-flex min-w-0 items-start gap-2 text-sm text-sky-100">
            <ClipboardCheck className="mt-0.5 h-4 w-4 shrink-0 text-sky-300" />
            <span className="min-w-0 break-words">
              <span className="font-display font-bold text-sky-200">Your set is collecting initials, pay by {fmtKST(b.payment_due)}</span>
              <span className="block text-xs text-sky-200/80">{b.title} · Set #{b.collected_sets.join(", #")} · {money(left(b))} due</span>
            </span>
          </span>
          <button type="button" data-testid={`collect-notice-pay-${b.drop_id}`} onClick={() => onPay([`d:${b.drop_id}`])}
            className="ml-auto rounded-full bg-sky-400 px-4 py-1.5 text-sm font-bold text-zinc-950 transition-colors hover:bg-sky-300">
            Pay now
          </button>
        </div>
      ))}
    </div>
  );
};
